import type { OutwriteShadesBrandColor } from '@outwrite/themes'

import styled from '@emotion/styled'

import { Item } from './Section'

import { TABLET_WIDTH_PX, MOBILE_WIDTH_PX } from '../constants'
import { COMMON_TITLE_CSS } from 'src/font'

export const StatWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  @media screen and (max-width: ${TABLET_WIDTH_PX}px) {
    flex-direction: column;
  }
  background: ${(props): string => props.theme.outwrite.colors.white};
  padding: 32px;
  border-radius: 8px;
`

export const StatDivider = styled(Item)`
  text-align: center;
  border-left: 1px solid transparent;
  border-right: 1px solid ${(props): string => props.theme.outwrite.colors.gray[200]};
  &:last-of-type {
    border-right-color: transparent;
  }

  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0;
  padding: 0 16px;

  @media screen and (max-width: ${TABLET_WIDTH_PX}px) {
    min-width: 70%;
    border-right-color: transparent;
    border-bottom: 1px solid ${(props): string => props.theme.outwrite.colors.gray[200]};
    padding-top: 32px;
    padding-bottom: 32px;
    &:first-of-type {
      padding-top: 0;
    }
    &:last-of-type {
      border-bottom-color: transparent;
      padding-bottom: 0;
    }
  }
`

interface StatNumbersProps { color?: keyof OutwriteShadesBrandColor }
export const StatNumbers = styled.p<StatNumbersProps>`
  ${COMMON_TITLE_CSS}
  ${(props): string => props.theme.outwrite.typos.title[900]}
  ${(props): string => props.color ? `color: ${props.theme.outwrite.colors[props.color][500]};` : ''}
  margin: 0 16px;
  @media screen and (max-width: ${MOBILE_WIDTH_PX}px) {
    ${(props): string => props.theme.outwrite.typos.title[700]}
  }
`

export const StatText = styled.p`
  margin: 0;
  font-weight: 600;
  color: ${(props): string => props.theme.outwrite.colors.gray[700]};
`
